import {decorate, observable, action} from 'mobx';
import EditStore from './editStore'

class ProjectStore extends EditStore {
    generalInformationDuringEdit = false
    customerDuringEdit = false
    filesDuringEdit = false
    discountsDuringEdit = false
    factoryDiscountDuringEdit = false
    collaborationDuringEdit = false

    duringSave = false
    duringCopy = false
    duringRevise = false
    duringDelete = false
    duringEditConfigurations = false

    addExistingConfigurationModalVisible = false
    chooseCustomerModalVisible = false
    deleteModalVisible = false

    dirty = false
    configurationIsValid = true

    manuallyAddedConfigurations = []

    canSave = () => {
        return !(this.generalInformationDuringEdit ||
            this.filesDuringEdit ||
            this.discountsDuringEdit ||
            this.factoryDiscountDuringEdit ||
            this.customerDuringEdit ||
            this.collaborationDuringEdit);
    }

    setAddExistingConfigurationModalVisible = value => this.addExistingConfigurationModalVisible = value

    setChooseCustomerModalVisible = value => this.chooseCustomerModalVisible = value

    setDeleteModalVisible = value => this.deleteModalVisible = value

    setDuringSave = value => this.duringSave = value;

    updateConfigurationItems(value) {
        const existing = this.formModel.configurations.items.map(x => x.guid);
        const newItems = value.filter(x => !existing.includes(x.guid)).map(x => x.guid);
        this.manuallyAddedConfigurations = this.manuallyAddedConfigurations.concat(newItems);
        this.formModel.configurations.items = value
    }

    updateCalculationItems(value) {
        const existing = this.formModel.calculations.items.map(x => x.guid);
        const newItems = value.filter(x => !existing.includes(x.guid)).map(x => x.guid);
        this.manuallyAddedConfigurations = this.manuallyAddedConfigurations.concat(newItems);
        this.formModel.calculations.items = value
    }

    updateConfigurationSummary(value) {
        this.formModel.summary = value
    }

    setFilesDuringEdit(duringEdit) {
        this.filesDuringEdit = duringEdit;
    }

    setDiscountsDuringEdit(duringEdit) {
        this.discountsDuringEdit = duringEdit;
    }

    setFactoryDiscountDuringEdit(duringEdit) {
        this.factoryDiscountDuringEdit = duringEdit;
    }

    setCollaborationDuringEdit(duringEdit) {
        this.collaborationDuringEdit = duringEdit;
    }

    setDirty(dirty) {
        this.dirty = dirty;
    }

    setConfigurationIsValid(value) {
        this.configurationIsValid = value;
    }

    setProductSerialNumber(guid, productSerialNumber) {
        const index = this.formModel.configurations.items.findIndex(x => x.guid === guid);
        if (index !== -1) {
            this.formModel.configurations.items[index].productSerialNumber = productSerialNumber;
        }
    }

    updateConfigurationIds(source) {
        source.forEach(s => {
            var index = this.formModel.configurations.items.findIndex(x => x.guid === s.guid);
            this.formModel.configurations.items[index].id = s.id;
            this.formModel.configurations.items[index].isNew = false;
        });

        this.formModel.configurations.items = [...this.formModel.configurations.items];
    }

    updateCalculationIds(source) {
        source.forEach(s => {
            var index = this.formModel.calculations.items.findIndex(x => x.guid === s.guid);
            this.formModel.calculations.items[index].id = s.id;
            this.formModel.calculations.items[index].isNew = false;
        });

        this.formModel.calculations.items = [...this.formModel.calculations.items];
    }
}

decorate(ProjectStore, {
    generalInformationDuringEdit: observable,
    customerDuringEdit: observable,
    filesDuringEdit: observable,
    collaborationDuringEdit: observable,
    discountsDuringEdit: observable,
    factoryDiscountDuringEdit: observable,
    addExistingConfigurationModalVisible: observable,
    chooseCustomerModalVisible: observable,
    deleteModalVisible: observable,
    dirty: observable,
    configurationIsValid: observable,

    duringSave: observable,
    duringCopy: observable,
    duringRevise: observable,
    duringDelete: observable,
    duringEditConfigurations: observable,

    setDirty: action,
    setFilesDuringEdit: action,
    setDiscountsDuringEdit: action,
    updateConfigurationSummary: action,
    setCollaborationDuringEdit: action
})

const store = new ProjectStore();
export default store;
